import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import '../../../styles/BodyInfo.css';
export default function BodyInfo(props) {
    
    const generateAChrId = () => {
        let firstName = props.member.firstName;
        let lastName = props.member.lastName;
        let chrIdNumber = props.member.passStatus.chrIdNumber;
        if (firstName === null || lastName === null || chrIdNumber === null) {
            return null;
        }
        if (chrIdNumber === 0) {
            return null;
        }
        if (firstName === "" || lastName === "") {
            return null;
        }
        var firstInitial = null;
        firstName = firstName.toLowerCase();
        lastName = lastName.toLowerCase();
        var letters = /^[A-Za-z]+$/;
        for (var i = 0; i<firstName.length; i++) {
            var letter = firstName.charAt(i);
            if (letter.match(letters)) {
                firstInitial = letter;
                break;
            }
        }
        if (firstInitial === null) {
            return null;
        } 
        var validLastName = "";
        for (var j = 0; j<lastName.length; j++) {
            var currentLetter = lastName.charAt(j);
            if (currentLetter.match(letters)) {
                validLastName += currentLetter;
            }
        }
        if (validLastName === "") {
            return null;
        }
        return firstInitial
            + validLastName
            + chrIdNumber;
    };
    const columnLeft = (stuff) => {
        return (<Col className="d-flex justify-content-start">{stuff}</Col>);
    };
    const columnRight = (stuff) => {
        return (<Col className="d-flex justify-content-end">{stuff}</Col>);
    };
    const styleBody = (label, value, styleObj) => {
        return (<><div className="style-body" style={styleObj}>{label}</div>{value}</>);
    };
    const displayChrUserId = () => {
        var contents;
        // don't display chrId because they don't have CHR or Notify as a service, and their chrid is null
        let styleObj = {};
        let needChrId = (props.member.chr || props.member.notify);
        let generatedChrId = generateAChrId();

        if (needChrId) {
            if (props.member.chrId === null) {
                styleObj = { backgroundColor: 'red', color: 'white' };
                contents = columnRight(styleBody("CHR ID", "Unknown", styleObj));
            } else {
                // not null
                if (props.member.chrId !== generatedChrId) {
                    styleObj = {backgroundColor: 'orange', color: 'white'};
                    contents = columnRight(styleBody("CHR ID", props.member.chrId, styleObj));
                } else {
                    contents = columnRight(styleBody("CHR ID", props.member.chrId, styleObj));
                }
            }
        }
        else {
            contents = columnRight(styleBody("CHR ID", "Not Required", styleObj));
        }
        return contents;
    };
    
    const displayGeneratedChrId = () => {
        let contents = (<></>);
        if (props.member.status === 'Inactive') {
            return contents;
        }
        let generatedChrId = generateAChrId();
        if (generatedChrId === null && (props.member.chr || props.member.notify)) {
            contents = columnRight(styleBody("Generated CHR ID", "Member Not Provisioned", { backgroundColor: 'red', color: 'white' }));
        }
        else {
            if (generatedChrId === props.member.chrId) {
                contents = columnRight(styleBody("Generated CHR ID", generatedChrId, {}));
            } else {
                contents = columnRight(styleBody("Generated CHR ID", generatedChrId, { backgroundColor: 'orange', color: 'white' }));
            }
        }
        return contents;
    };

    const displayStateLicense = () => {
        let contents = (<></>);
        if (props.member.stateLicense !== null) {
            let stateLicense = props.member.stateLicense !== null ? props.member.stateLicense : "Unknown";
            contents = columnRight(styleBody("State License", stateLicense, {}));
        }
        return contents;
    };

    const memberServices = () => {
        var services = "";
        let styleObj = {};
        if (props.member.chr) {
            services += "CHR;";
        }
        if (props.member.notify) {
            services += "Notify;";
        }
        if (props.member.dsm) {
            services += "DSM;";
        }
        if (props.member.referrals){
            services += "Referrals;";
        }
        if (services === "") {
            services = "No Services";
            styleObj = {backgroundColor: 'orange', color: 'white'};
        }
        return columnLeft(styleBody("Current Services", services, styleObj));
    };

    const displayNpiNum = () => {
        let contents = (<></>);
        if (props.member.npi !== null) {
            contents = columnRight(styleBody("NPI", props.member.npi, {}));
        }
        return contents;
    };

    return (
        <Container className="style-box">
            <Row>
                {columnLeft(styleBody("Name", props.member.firstName + " " + (props.member.middleName? props.member.middleName + " " :"") + props.member.lastName, {}))}
                {columnRight(styleBody("SF ID", props.member.id, {}))}
            </Row>
            <Row>
                {columnLeft(styleBody("Org/Dept", props.member.account.legalName !== null ? props.member.account.legalName : "Unknown", {}))}
                {columnRight(styleBody("Created on", props.member.readableCreatedDate, {}))}
            </Row>
            <Row>
                {columnLeft(styleBody("Email", props.member.email !== null ? props.member.email : "Unknown", {}))}
                {displayChrUserId()}
            </Row>
            {(props.member.chr || props.member.notify) && <Row>{displayGeneratedChrId()}</Row>}
            <Row>
                {columnLeft(styleBody("Tel", props.member.phone !== null ? props.member.phone : "Unknown", {}))}
                {displayNpiNum()}
            </Row>
            <Row>
                {memberServices()}
                {displayStateLicense()}
             </Row>
        </Container>
    )
}